import React, { useEffect, useRef } from 'react';
import {
  Button,
  Container,
  ContentLayout,
  Form,
  Header,
  SpaceBetween,
  TextContent,
} from '@amzn/awsui-components-react';
import { useIntl } from 'react-intl';
import pageTimeOutMessages from '../i18n/pageTimeOut.messages';
import Main from './Main';
import ContainerLayout from './ContainerLayout';
import { AppConfig } from '../types/app';
import { emitPostAuthRumEvent } from '../services/emitPostAuthRumEvent';
import { GandalfUser } from '../types/auth';
import { IMPRESSIONS, PostAuthRumEvent } from '../constants/metrics';
import metricsService from '../services/metrics';

export const PageTimeOutModal = ({
  config,
  user,
}: {
  config: AppConfig;
  user: GandalfUser;
}) => {
  const { formatMessage } = useIntl();
  const metricsPublisher = useRef(metricsService.getPublisher('PageTimeOut'));
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      //Publish metrics to both Katal and RUM
      emitPostAuthRumEvent(user, PostAuthRumEvent.PAGE_TIME_OUT);
      metricsPublisher.current.publishCounterMonitor(IMPRESSIONS, 1);
      isFirstRender.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Main config={config}>
        <ContainerLayout enableResponsiveStyles>
          <ContentLayout>
            <Container
              header={
                <Header variant={'h2'}>
                  {formatMessage(pageTimeOutMessages.header)}
                </Header>
              }
            >
              <Form
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.reload();
                      }}
                      data-testid={'refresh-page'}
                      variant={'primary'}
                    >
                      {formatMessage(pageTimeOutMessages.button)}
                    </Button>
                  </SpaceBetween>
                }
              >
                <SpaceBetween direction="vertical" size="xs">
                  <TextContent>
                    {formatMessage(pageTimeOutMessages.containerBody)}
                  </TextContent>
                </SpaceBetween>
              </Form>
            </Container>
          </ContentLayout>
        </ContainerLayout>
      </Main>
    </>
  );
};
